import React from "react";
import Avatar from "../../Components/Avatar";
import Button from "../../Components/Button";
import { EmployeeSelector } from "../../Components/Selectors/EmployeeSelector";
import css from "./styles.styl";

const SuperUserModal = ({ 
    selectedEmployee, 
    environment, 
    onEmployeeSelect, 
    onCancel, 
    onConfirm 
}) => {
    if (selectedEmployee) {
        return (
            <div className={css.modalContent}>
                <div className={css.employeeInfo}>
                    <div className={css.avatar}>
                        <Avatar userID={selectedEmployee._id} size={48} />
                    </div>
                    <div className={css.details}>
                        <h3>{selectedEmployee.name}</h3>
                        <p>{selectedEmployee.email}</p>
                        {selectedEmployee.company && <p>{selectedEmployee.company}</p>}
                    </div>
                </div>
                <div className={css.actionButtons}>
                    <Button color="grey" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button color="green" onClick={onConfirm}>
                        Make Super User
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className={css.modalContent}>
            <EmployeeSelector environment={environment} onChange={onEmployeeSelect} />
        </div>
    );
};

export default SuperUserModal;